import { QuoteUrlConstant } from 'src/constants';
import {
  GetQuoteChartDto,
  GetQuoteChartResponseDto,
  GetQuoteDto,
  GetQuoteListDto,
  GetQuoteListResponseDto,
  QuoteDto,
} from 'src/dtos';
import { WithAuthToken, replacePlaceholders, httpRequest } from 'src/utils';

export class QuoteApi {
  async list({ queryParams, authToken }: WithAuthToken<GetQuoteListDto>): Promise<GetQuoteListResponseDto> {
    return httpRequest<GetQuoteListResponseDto>({
      method: 'GET',
      url: QuoteUrlConstant.LIST,
      queryParams,
      authToken,
    });
  }

  async retrieve({ params, authToken }: WithAuthToken<GetQuoteDto>): Promise<QuoteDto> {
    const url = replacePlaceholders(QuoteUrlConstant.RETRIEVE, {
      symbol: params.symbol,
    });

    return httpRequest<QuoteDto>({
      method: 'GET',
      url,
      authToken,
    });
  }

  async retrieveChart({
    params,
    queryParams,
    authToken,
  }: WithAuthToken<GetQuoteChartDto>): Promise<GetQuoteChartResponseDto> {
    const url = replacePlaceholders(QuoteUrlConstant.GET_CHART, {
      symbol: params.symbol,
    });

    return httpRequest<GetQuoteChartResponseDto>({
      method: 'GET',
      url,
      queryParams,
      authToken,
    });
  }
}
